const de = {
    index: {
        headline: 'First Class Performance GmbH',
        subline: '',
        friends: 'Unsere Freunde',
    },
    links: {
        index: {
            name: 'First Class Performance GmbH',
            title: 'First Class Performance GmbH Hannover',
            description: 'First Class Performance GmbH Hannover ☆ Fitness, Training & Kurse ☆ Exklusive Betreuung ☆ Zielgerichtete Trainingspläne ☆ Jetzt Kennenlerngespräch buchen!',
        },
        ssp: {
            name: 'Trainingspläne',
            title: 'Trainingspläne',
            description: 'First Class Performance GmbH Hannover ☆ Sport Specific Preparation',
        },
        ssparchiv: {
            name: 'Sport Specific Preparation Archiv',
            title: 'Sport Specific Preparation Archiv',
            noentries: 'Keine Posts vorhanden.',
            description: 'First Class Performance GmbH Hannover ☆ Sport Specific Preparation Archiv',
        },
        studio: {
            name: 'Unser Gym',
            title: 'First Class Performance GmbH Hannover - Unser Gym',
            description: 'First Class Performance GmbH Hannover ☆ Galerie ☆ Eindrücke aus unserer Box. Fotos unseres Fitnessstudios, der Sportgeräte und der Kurse.',
        },
        team: {
            name: 'Unser Team',
            title: 'First Class Performance GmbH Hannover - Unser Team',
            description: 'First Class Performance GmbH Hannover ☆ Übersicht und Informationen zu unseren erfahrenen Fitness Trainern und Trainer-Team.',
        },
        vision: {
            name: 'Erfahrung und Vision',
            title: 'First Class Performance GmbH Hannover - Unsere Erfahrung und Vision',
            description: 'First Class Performance GmbH Hannover ☆ Übersicht und Informationen zu unserer Fitness Erfahrung und Vision.',
        },
        courses: {
            name: 'Kurse',
            title: 'First Class Performance GmbH Hannover - Unsere Kurse',
            description: 'First Class Performance GmbH Hannover ☆ Übersicht unserer und Fitness-Kurse. Kursangebote und Beschreibungen der Trainingseinheiten.',
        },
        fitness: {
            name: 'Fitness',
            about: 'Was ist Fitness?',
            title: 'First Class Performance GmbH Hannover - Fitness Hannover',
            description: 'First Class Performance GmbH Hannover ☆ Was ist Fitness? Wissenswertes über Impressionen aus unserem Gym.',
        },
        imprint: {
            name: 'Impressum',
            title: 'First Class Performance GmbH Hannover - Impressum',
            description: 'First Class Performance GmbH Hannover ☆ Impressum, Adresse, Kontakt',
        },
        privacy: {
            name: 'Datenschutz',
            title: 'First Class Performance GmbH Hannover - Datenschutz',
            description: 'First Class Performance GmbH Hannover ☆ Datenschutz Informationen Cookie-Einstellungen',
        },
        pricing: {
            name: 'Preise',
            title: 'First Class Performance GmbH Hannover - Preise',
            description: 'First Class Performance GmbH Hannover ☆ Die Preise und Mitgliedschaften unserer Kurse und zur Nutzung unseres Trainings-Equipments.',
        },
        trial: {
            name: 'Gespräch buchen',
            title: 'First Class Performance GmbH Hannover - Kennenlerngespräch buchen',
            description: 'First Class Performance GmbH Hannover ☆ Training Hannover ☆ Jetzt ein Kennenlerngespräch buchen und unsere Kurse und Gym ausprobieren.',
        },
        home: {
            name: 'Home',
            title: 'First Class Performance GmbH Hannover',
            description: 'First Class Performance GmbH Hannover ☆ Home Homepage',
        },
        contact: {
            name: 'Kontakt',
            title: 'First Class Performance GmbH Hannover - Kontakt',
            description: 'First Class Performance GmbH Hannover ☆ Kontakt Termin Absprachen Hilfe. Jetzt ein Kennenlerngespräch buchen.',
        },
        about: {
            name: 'Über Uns',
            title: 'First Class Performance GmbH Hannover - Über Uns',
            description: 'First Class Performance GmbH Hannover ☆ Allgemeine Informationen über unser Gym, unsere Trainer und unser Trainings-Equipment.',
        },
        bookConversation: 'Gespräch buchen',
        blogs: {
            all: {
                name: 'Blog Posts',
                title: 'First Class Performance GmbH Hannover - Alle Blog Posts',
                description: 'First Class Performance GmbH Hannover ☆ Blog Posts - Alle unsere Blog Posts 2021 - Aktuelles und Traingsplaene!',
            },
            all2020: {
                name: 'Blog Posts 2020',
                title: 'First Class Performance GmbH Hannover - Alle Blog Posts 2020',
                description: 'First Class Performance GmbH Hannover ☆ Blog Posts - Alle unsere Blog Posts 2020 - Aktuelles und Traingsplaene!',
            },
        },
        user: {
            login: {
                name: 'Login',
                title: 'First Class Performance GmbH Hannover - Login Member',
                description: 'First Class Performance GmbH Hannover ☆ Login zum exklusivem Member-Bereich mit Trainingsplänen.',
            },
            logout: {
                name: 'Logout',
                title: 'First Class Performance GmbH Hannover - Logout Member',
                description: 'First Class Performance GmbH Hannover ☆ Logout des exklusivem Member-Bereich mit Trainingsplänen.',
            },
            register: {
                name: 'Registrieren',
                title: 'First Class Performance GmbH Hannover - Registrierung Member',
                description: 'First Class Performance GmbH Hannover ☆ Registrierung zum exklusivem Member-Bereich mit Trainingsplänen.',
            },
            forgotPassword: {
                name: 'Passwort vergessen',
                title: 'First Class Performance GmbH Hannover - Passwort vergessen',
                description: 'First Class Performance GmbH Hannover ☆ Passwort vergessen für Member-Bereich.',
            },
            resetPassword: {
                name: 'Passwort zurücksetzen',
                title: 'First Class Performance GmbH Hannover - Passwort zurücksetzen',
                description: 'First Class Performance GmbH Hannover ☆ Passwort zurücksetzen für Member-Bereich.',
            },
            emailVerification: {
                name: 'E-Mail verifizieren',
                title: 'First Class Performance GmbH Hannover - E-Mail verifizieren',
                description: 'First Class Performance GmbH Hannover ☆ Passwort zurücksetzen für Member-Bereich.',
            },
            sendVerificationMail: {
                name: 'Verifizierungsmail versenden',
                title: 'First Class Performance GmbH Hannover - Verifizierungsmail versenden',
                description: 'First Class Performance GmbH Hannover ☆ Passwort zurücksetzen für Member-Bereich.',
            },
            settings: {
                name: 'Einstellungen',
                title: 'First Class Performance GmbH Hannover - Einstellungen',
                description: 'First Class Performance GmbH Hannover ☆ Passwort zurücksetzen für Member-Bereich.',
            },
            profile: {
                name: 'Member Area',
                title: 'First Class Performance GmbH Hannover - Member Area',
                description: 'First Class Performance GmbH Hannover ☆ Member Area',
            },
        },
        datenschutz: {
            name: 'Datenschutz',
            title: 'First Class Performance GmbH Hannover - Datenschutz',
            description: 'First Class Performance GmbH Hannover ☆ Datenschutz Informationen Cookie-Einstellungen',
        },
    },
    footer: {
        links: 'Informationen',
        partner: 'Unsere Partner',
    },
    content: {
        herocarousel: {
            button: 'Kennenlerngespräch buchen',
        },
        ssp: {
            headline: 'Unsere Trainingspläne für euch!',
            description: 'Auf dieser Seite findest Du die Sportarten, für die wir aktuell ein Strength & Conditioning Trainingsprogramm anbieten. Egal ob Maximalkraft, Schnellkraft, Ausdauer oder Geschwindigkeit - wir setzen die Prioritäten anhand deiner Sportart und den entsprechenden Anforderungen. Sollte Deine Sportart nicht gelistet sein oder solltest du andere Fragen zu den Trainingsprogrammen haben, so schreib uns gerne ueber unser Kontaktformular.',
            profileinfo: 'Als Kunde findest du deine abonnierten Sportpakete in deinem ',
            archivelink1: 'Alle ',
            archivelink2: ' Beiträge ansehen',
        },
        contact: {
            headline: 'Kontakt',
            intro: 'Egal ob Frage, Kritik oder Anregung – oder wenn ihr einfach Lust habt mal unverbindlich auszuprobieren, schreibt uns eine E-Mail oder ruft uns an! In den First Class Performance GmbH Öffnungszeiten seht ihr wann wir in der Box anzutreffen sind. Wenn Ihr neugierig geworden seid, kommt uns einfach mal besuchen und seht euch ein Training an! Wir freuen uns auf euch!',
            comeIn: 'Schaue vorbei',
            writeUs: 'Kontaktiere uns',
            callUs: 'Rufe uns an',
            followUs: 'Follow us',
            comeInIntro: 'Schaue einfach in unserem Gym vorbei, damit wir uns persönlich kennenlernen können. So findest Du uns:',
            comeInText: 'Komme einfach während unserer Öffnungszeiten vorbei und lerne uns kennen.',
            driveHeadline: 'Anfahrt',
            driveText1: 'Direkt an der Vahrenwalder Straße gelegen, in direkter Nähe zur A2!',
            driveText2: 'Mit der Straßenbahn vom Hauptbahnhof in nur 7 Minuten zu erreichen!',
            directionsHeadline: 'Wegbeschreibung',
            directionsText1: 'Wenn du von der Vahrenwalder Str. kommst, weil du z.B. aus der Bahn an der Haltestelle "Windaustr." gestiegen bist, gehst du auf das Gewerbegebiet rechts neben Media Markt, bis zur Tür mit einem großen "A" darauf. Die Wendeltreppe hoch und durch die rechte Tür.',
            directionsText2: 'Falls du von der Büttnerstr. kommst, biegst du von der anderen Seite auf das Gewerbegebiet ein. Einfahrt ist beim "Sambo 07". Dort einfach geradeaus, zweite Abbiegung rechts, wo unser ehemaliger Eingang über die rote Treppe ist, da dann einfach geradeaus-links und dann ist dort die Tür mit dem "A" drauf.',
            directionsText3: 'Parken kann man auf der Vahrenwalder Str. und Büttnerstr. gebührenfrei. Falls du auf dem Media Markt Parkplatz parken solltest, beachte bitte die Öffnungszeiten von Media Markt! 😉',
            callUsText1: 'Rufe uns einfach an unter der Rufnummer ',
            callUsText2: ' Wir sind für Dich jeden Tag zu unseren Öffnungszeiten zu erreichen.',
            callUsText3: ' Du kannst uns auch gerne via WhatsApp kontaktieren.',
            callUsText: 'Du kannst uns telefonisch oder per WhatsApp unter der Nummer +49 511 84485950 erreichen.',
            followUsText1: 'Für weitere Infos und ständige Updates folge uns auf unseren Social Media Kanälen!',
            writeUsText1: 'Sende uns eine E-Mail an ',
            writeUsText2: ' oder nutze direkt unser Kontaktformular',
            stayInTouch: 'Lass uns in Kontakt bleiben',
            stayInTouchText: 'Folge uns auf Social Media für die neuesten Updates, Angebote und Einblicke in unser Gym.',
        },
        trial: {
            headline: 'Kennenlerngespräch buchen bei First Class Performance GmbH',
            subline: 'Jeder ist bei uns willkommen. Schau einfach mal rein.',
            teaser: 'Du bist neu bei uns? Dann komme einfach zum kostenlosen Kennenlerngespräch vorbei. Schreibe uns per E-Mail oder Whatsapp oder rufe uns direkt an, um dir einen Platz zu sichern.',
            offer: 'Während der Öffnungszeiten kannst du jederzeit vorbeikommen, mit den Trainern quatschen, dich in unserer Box austoben, Geräte ausprobieren oder dich unverbindlich beraten lassen. Unser Gym ist gut zu erreichen mitten in Hannover gelegen. Klicke einfach unten auf "Kontakt" um zu uns zu finden.',
            offerCourse: 'Hast du Interesse an einem bestimmten Kurs? Ruf uns an, schreib uns ne Mail und wir verabreden gerne eine Probestunde mit Dir!',
            foundation: 'Wenn dir das Kennenlerngespräch gefallen hat, hast Du danach die Möglichkeit uns weiter kennenzulernen. Buche einfach unser exklusives Foundation-Programm für 80€. Das Programm beinhaltet: 6 Foundation Kurse, 2 Workouts of the Day (WoD\'s). Und das Beste: Du brauchst hierfür keine Aufnahmegebühr zu zahlen und gehst keine Vertragsbindung ein.',
            contactLabel: 'Kontakt',
            equipment: 'Für ein erstes Kennenlerngespräch brauchst du nichts weiter, als bewegliche Sportklamotten, ein Handtuch, eine Wasserflasche und Lust auf was Neues!',
            helptext: 'Falls Du noch Fragen hast, kannst Du uns selbstverständlich gerne während der Geschäftszeiten anrufen.',
            findus: 'Wie Du zu uns findest, erfährst Du hier',
            findusLabel: 'Anfahrt',
        },
        courses: {
            headline: 'Unser Kursangebot',
            headlinePlan: 'Unser Kursplan',
            title: 'Unsere Kurse',
            description: 'First Class Performance GmbH Hannover - Übersicht unserer Fitness-Kurse und Trainingseinheiten.',
            wotd: {
                headline: 'Workout of the day',
                subline: 'Mehrteiliges Allround Training',
                body: '',
            },
            foundations: {
                headline: 'Foundations',
                subline: 'Dein Erstkontakt',
                body: 'Der Foundationkurs ist der erste Kontakt mit Fitness. Wir werden euch in sechs Classes alle Grundtechniken unseres Trainings vermitteln und euch mit dem "Vokabular" vertraut machen.\n' +
                    'Danach habt ihr die Möglichkeit an zwei regulären WoDs teilzunehmen. Ihr braucht für den Foundationskurs keine Vorerfahrung und müsst auch kein bestimmten Fitnesslevel mitbringen. Die Foundationkurse umfassen jeweils etwa 60 Minuten und sind natürlich größtenteils praktisch.\n',
            },
            wodlight: {
                headline: 'WOD Light',
                subline: 'Weniger Last, Mehr Wiederholung als im WOD',
                body: 'Wir arbeiten hier grundsätzlich mit dem gleichen Aufbau und Bewegungsmustern des "WODs", allerdings wird der Stimulus etwas geändert. Die Lasten werden ggf. reduziert, die Wiederholungszahlen erhöht. Falls man sich an einem Tag mal nicht nach schweren Lasten oder Krafttraining fühlt, sondern eher aus der Puste geraten möchte, bieten wir hier die ideale Alternative für den Wiedereinstieg ins Training – All die Kleinigkeiten der "Körperpflege" und Accessory-Übungen, die innerhalb eines WODs vielleicht keinen Platz mehr finden, haben hier ihr Zuhause.',
            },
            olympicweights: {
                headline: 'Olympic Weightlifting',
                subline: 'Gewichtheben in Kleingruppen',
                body: 'Wir bieten sowohl geleitete Classes im Bereich olympisches Gewichtheben (OLY) als auch die Möglichkeit unseren Barbell Club für eigenverantwortliches Training in dem Bereich zu nutzen. \n' +
                    'An fünf Tagen der Woche bieten wir auch noch ein Extra Trainingsprogramm für Gewichtheben/Powerlifting in unserer App an. Für mehr Infos sprecht uns gerne direkt in der Box an!\n',
            },
            powerlifting: {
                headline: 'Powerlifting',
                subline: 'Eigenverantwortliches Gewichtheben',
                body: 'Wer sich dem Kraftdreikampf verschrieben hat findet auch bei uns die Möglichkeit zu trainieren. In unserem Barbell Club bieten wir allen Interessierten die Möglichkeit eigenverantwortlich ihr Krafttraining zu absolvieren.',
            },
            yoga: {
                headline: 'Yoga',
                subline: 'Der Klassiker aus Indien. Strengt an. Entspannt.',
                body: 'Wir bieten mehrmals die Woche Yoga in einem separaten Yoga-Raum an.',
            },
            pilates: {
                headline: 'Pilates',
                subline: 'Systematisches Ganzkörpertraining zur Kräftigung der Muskulatur',
                body: 'Wir bieten zur Unterstützung des Fitness Trainings mehrmals wöchentlich Pilates an. Dies wird in einem separaten Raum unterrichtet.',
            },
            mobility: {
                headline: 'Mobility',
                subline: 'Damit ihr für alles gewappnet seid',
                body: 'Mit Lacrossebällen, Bändern, Blöcken und Rollen wird hier in einem separaten Raum unter Anleitung unserer Coaches an der Verbesserung der Mobilität und Milderung kleinerer Wehwehchen gearbeitet.',
            },
            functionalbb: {
                headline: 'Functional Bodybuilding',
                subline: 'Allroundtraining und gezieltes trainieren der \'Problemzonen\'',
                body: 'Verletzungsprävention, Kräftigung einzelner Positionen, Verbesserung der Bewegungsqualität, Austarieren von etwaigen Dysbalancen und gegebenenfalls sogar Rehabilitationsübungen nach Verletzungen für den Wiedereinstieg ins Training – All die Kleinigkeiten der "Körperpflege" und Accessory-Übungen, die innerhalb eines WODs vielleicht keinen Platz mehr finden, haben hier ihr Zuhause.',
            },
            romwod: {
                headline: 'ROM WOD',
                subline: 'Absolviere virtuell ein offizielles ROMWOD Training',
                body: 'Unsere Mitglieder haben alle die Möglichkeit mittels Cybertraining durch ROMWOD eigenständig Mobility Training zu absolvieren.',
            },
        },
        crossfit: {
            headline: 'Was ist Fitness?',
            body: 'Fitness bedeutet mehr als nur Training. Es bedeutet, dein Leben besser zu machen. Fitness ist für uns nicht einfach ein Workout – es ist die Fähigkeit, mehr aus deinem Leben herauszuholen: mehr Energie im Alltag, mehr Kraft im Körper, mehr mentale Stärke. Unser Ansatz basiert auf einer simplen, aber kraftvollen Definition:',
            body2: 'Fitness ist die gesteigerte Leistungsfähigkeit über verschiedene Zeitspannen und Bewegungsarten hinweg.',
            body3: 'Oder einfacher gesagt: Du wirst stärker, schneller, ausdauernder – und zwar in allen Lebensbereichen.',
            body4: 'Wir entwickeln deine Fitness gezielt über zehn grundlegende körperliche Fähigkeiten:',
            body5: 'Warum das für dich wichtig ist? Weil diese Fähigkeiten die Grundlage für ein gesundes, belastbares Leben sind.',
            body6: 'Fitness steht auf einem Kontinuum mit Gesundheit – je fitter du bist, desto weiter entfernst du dich von Krankheit und Verletzungsanfälligkeit.',
            body7: 'Gesundheit ist kein Ziel – es ist ein Prozess. Fitness bringt dich jeden Tag ein Stück weiter.',
            body8: 'Kein Training von der Stange – sondern ein Plan, der zu dir passt.',
            body9: 'Bei uns gibt es kein „One Size Fits All“-Programm. Du bekommst ein individuell angepasstes Training in einem Gruppensetting, das auf dich abgestimmt ist: Dein Können, deine Ziele, dein Alltag – alles fließt in unser Coaching ein.',
            body10: 'Egal ob du Anfänger bist oder schon Erfahrung hast: Wir holen dich dort ab, wo du stehst – und bringen dich genau dorthin, wo du hinwillst.',
            body11: 'Du willst stärker werden? Fitter? Schmerzfrei? Selbstbewusster? Dann ist es Zeit deine Reise zu starten – mit Training, das für dich gemacht ist.',
        },
        team: {
            headline: 'Unser Team',
            carousel: 'Das sind wir',
        },
    },
    contactForm: {
        headline: 'Contact Us',
        personalDataHeadline: 'Persönliche Daten',
        messageHeadline: 'Deine Nachricht an uns',
        email: 'E-Mail Adresse',
        firstName: 'Vorname',
        lastName: 'Nachname',
        subject: 'Betreff',
        message: 'Nachricht',
        send: 'Senden',
        success: 'Vielen Dank. Deine Nachricht wurde erfolgreich versendet. Wir werden Dich bald kontaktieren.',
        error: 'Es ist ein Fehler aufgetreten. Bitte versuche Deine Nachricht noch einmal zu senden oder schicke sie direkt per E-Mail an moritz@first-class-performance.com.',
        privacyText: 'Bitte beachte unsere ',
        privacyLink: 'Datenschutzerklärung',
    },
    errors: {
        required: {
            firstName: 'Vorname muss gefüllt sein',
            lastName: 'Nachname muss gefüllt sein',
            email: 'Die E-Mail-Adresse muss gefüllt sein.',
            subject: 'Betreff muss gefüllt sein',
            message: 'Nachricht muss gefüllt sein',
        },
        invalid: {
            email: 'Die E-Mail-Adresse ist ungültig',
        },
        defaultError: 'Es ist ein Fehler aufgetreten',
        errorPage: 'Please contact support@pnn-it.de',
    },
    pricing: {
        headline: 'Unsere Preise und Mitgliedschaften',
        teasertext: 'Bei uns hast Du die Wahl zwischen drei Paketen, sowie dem Einstiegskurs. Um von allen Vorteilen zu profitieren und jederzeit alles zu geben, empfehlen wir dir unser Unlimited-Paket.',
        trialpart1: 'Du bist neu bei uns? Willst Fitness kennenlernen? Dann vereinbare einfach dein ',
        trialpart2: 'kostenloses Kennenlerngespräch.',
        discountpart1: 'Du bist Azubi oder Student? Dann checke auch unsere ',
        discounts: 'Rabatte',
        discountpart3: ' aus.',
        hansefitHeadline: 'Hansefit',
        hansefitBody: 'Mit einer Hansefit-Mitgliedschaft über deine Arbeitsstelle kannst du täglich an einem Kurs bei uns teilnehmen ohne extra Kosten tragen zu müssen. Trainieren im OpenGym, Yoga und Olympisches Gewichtheben sind nicht in der Hansefit-Mitgliedschaft enthalten. Über den Hansefit-QR-Code auf unserem Tresen, kannst du dich ganz easy einloggen.',
        personaltrainings: 'Personal Trainings',
        personaltrainingsinfo: 'Ein 45-minütiges 1on1 Coaching mit einem Trainer deiner Wahl.\n' +
            '\n' +
            'Du möchtest an deinen Butterfly Pullups arbeiten, dein Barbell Cycling verbessern oder einfach nur noch einmal in aller Ruhe die Basics wie Medball Cleans oder Kettlebell-Swings durchgehen?\n' +
            '\n' +
            'Vereinbare einen Termin mit einem Trainer deiner Wahl und sprich im Vorfeld dein Sitzungsziel mit deinem Coach ab und genieße 100% der Aufmerksamkeit um Dich in deinem Training voran zu bringen.',
        questions: 'Du hast Fragen? Dann rufe oder schreibe uns einfach an.',
        clubdiscount: 'Spezielle Konditionen für Vereine, Unternehmen und Gruppen',
        businessdiscount: 'Wir bieten spezielle Kooperationen für Vereine, Unternehmen und (Betriebssport-)gruppen nach Absprache an. Du kannst für Dein Unternehmen/Gruppe einen exklusiven Zeitslot mit uns vereinbaren. In dieser Zeit stehen unsere Box und unsere Trainer ausschließlich Deiner Gruppe zur Verfügung, damit Ihr gemeinsam trainieren könnt.',
        dropin: 'Drop-Ins',
        dropinpart1: 'Sehr gerne begrüßen wir jede Art von Besuchenden und Fitness-Begeisterten bei uns in der Box. Wenn du ein Drop-In buchen möchtest, schreibe uns bitte vorher eine Mail, damit wir dir einen Platz reservieren können. \n' +
            'Falls du einen längeren Aufenthalt in Hannover planst, arbeiten wir auch gerne ein spezifisches Angebot für dich aus!',
        dropinpart2: 'We love throwing down with visitors and Fitness enthusiasts from all over the world, but would kindly ask you to write us an E-Mail in advance to reserve your spot. Our Drop-in price is either 15€ or you buy a shirt!  For a longer stay, feel free to contact us directly to work out a plan for you!',
        row1: [
            {
                title: 'Try Out 5er Karte',
                subheader: 'Ideal zum Ausprobieren',
                priceMonthly: 'Einmalig 50€',
                priceYearly: '',
                ignoreToggle: true,
                description: [
                    'In diesen 5 geführten Classes kannst du dir ein Bild machen was dich bei uns erwartet: Community-Feeling, abwechslungsreiches und zielorientiertes Programming und Trainingsspaß vom Feinsten!',
                    'Keine Vertragsbindung',
                    'Keine Aufnahmegebühr',
                    'Unverbindlich testen',
                ],
                buttonText: 'Jetzt anfragen',
                buttonVariant: 'contained',
                buttonColor: 'secondary',
            },
        ],
        row2: [
            {
                title: '16 Sessions pro Monat',
                subheader: 'Der perfekte Einstieg',
                priceMonthly: '99€ / Monat',
                priceYearly: '82,50€ / Monat',
                description: [
                    '8x Class nach Wahl mit Coach',
                    '8x Open Gym',
                    'Trainingstagebuch "Beyond the Whiteboard"',
                    'Zugang zum "Extra Work"-Trainingsplan im Mitgliederbereich',
                ],
                buttonText: 'Jetzt anfragen',
                buttonVariant: 'outlined',
                buttonColor: 'secondary',
            },
            {
                title: '24 Sessions pro Monat',
                subheader: 'Preis-Leistungssieger',
                priceMonthly: '119€ / Monat',
                priceYearly: '99€ / Monat',
                description: [
                    '12x Class nach Wahl mit Coach',
                    '12x Open Gym',
                    'Trainingstagebuch "Beyond the Whiteboard"',
                    'Zugang zum "Extra Work"-Trainingsplan im Mitgliederbereich',
                ],
                buttonText: 'Jetzt anfragen',
                buttonVariant: 'outlined',
                buttonColor: 'secondary',
            },
            {
                title: 'Unlimited',
                subheader: '#hardworkpaysoff #hwpo',
                priceMonthly: '179€ / Monat',
                priceYearly: '149€ / Monat',
                description: [
                    'Unlimitierte Anzahl an Classes mit Coach und Open Gym',
                    'Trainingstagebuch "Beyond the Whiteboard"',
                    'Zugang zum "Extra Work"-Trainingsplan im Mitgliederbereich',
                ],
                buttonText: 'Jetzt anfragen',
                buttonVariant: 'contained',
                buttonColor: 'secondary',
            },
        ],
    },
    privacy: {
        footer: 'Ihr Datenschutz',
    },
    imprint: {
        headline: 'Impressum',
        owner: 'Geschäftsführer: Moritz Hauser',
        taxnumber: 'Steuer-Nr.: 25/201/35993',
        uid: 'UID-Nr.: DE313764808',
        fb: 'FB-Nr. / HG-Nr.: 215695',
        iban: 'IBAN: DE50251900010783758500',
        bic: 'BIC: VOHADE2H',
        traderegister: 'Amtsgericht Hannover HRB 215695',
        legalInfo: 'Nachstehende Informationen erteilen wir gemäß § 5 Telemediengesetz (TMG):',
        subline: 'Verantwortlich für den Inhalt gem. § 55 Abs. 2 RStV',
        liability: {
            headline: 'Haftungshinweis',
            body: 'Für Verweise auf unseren Seiten möchten wir ausdrücklich betonen, dass wir keinerlei Einfluss auf den Linktext, die Gestaltung, evtl. Verletzungen geltender Rechte, auch Marken- und Titelrechte und die Inhalte der gelinkten Seiten haben. Wir distanzieren uns ausdrücklich von den Linkformulierungen, sowie von allen Inhalten aller Seiten auf die wir Verweise gesetzt haben und machen uns ihre Inhalte nicht zu eigen. Diese Erklärung gilt für alle auf unserer Website angebrachten Links und für alle Inhalte der Seiten, zu denen die bei uns angemeldeten Banner oder Links führen.\n' +
                '\n' +
                'Wir bemühen uns, möglichst genaue und zuverlässige Informationen auf unseren Webseiten zu veröffentlichen. Wir können jedoch keinerlei Gewähr für die Richtigkeit aller veröffentlichten Informationen leisten. Jegliche Haftung für den Fall von Irrtümern oder Auslassungen auf unseren Webseiten wird ausgeschlossen.',
        },
        disputeresolution: {
            headline: 'Streitschlichtungsplattform Information',
            body: 'Die EU-Kommission bietet die Möglichkeit zur Online-Streitbeilegung auf einer von ihr betriebenen Online-Plattform. Diese Plattform ist über den externen Link http://ec.europa.eu/consumers/odr/ zu erreichen. Zu einer Teilnahme an einem Schlichtungsverfahren sind wir nicht verpflichtet und können die Teilnahme an einem solchen Verfahren leider auch nicht anbieten.',
        },
        footer: {
            headline: 'Repräsentiert durch',
            company: 'First Class Performance GmbH',
        },
    },
    cookie: {
        acceptbutton: 'Cookies akzeptieren',
        settingsbutton: 'Cookie-Einstellungen',
        infobutton: 'Datenschutzerklärung',
        headline: 'Diese Seite speichert und verwendet die folgenden Cookies',
        consentinfo: 'Mit Hilfe von Cookies können wir sicherstellen, dass Sie das beste Erlebnis auf unserer Website haben. Um Cookies zu aktivieren, klicken Sie bitte auf "Cookies akzeptieren" oder "Cookie-Einstellungen". Ihre Einwilligung können Sie jederzeit unter "Cookie-Einstellungen" widerrufen. Bitte lesen Sie auch unsere ',
        settings: {
            title: 'Datenschutzeinstellungen',
            savebutton: 'Speichern',
            acceptallbutton: 'Alle akzeptieren',
            technicalCookies: 'Technisch notwendige Cookies',
            technicalText: 'Diese Cookies sind zur Funktion unserer Website erforderlich. Cookies werden als Reaktion getätigter Aktionen gesetzt, z.B. dem Festlegen der Datenschutzeinstellungen.',
            externalContentCookies: 'Anzeige externer Inhalte',
            externalContentText: 'Ich bin damit einverstanden, dass mir externe Inhalte angezeigt werden. Damit können personenbezogene Daten an Drittplattformen übermittelt werden. Mehr dazu in unserer Datenschutzerklärung.',
        },
        instagramDescription: 'Um an dieser Stelle einen unserer Instagram-Beiträge mit wissenswerten Infos, Fotos und Videos anzuzeigen, benötigen wir Deine Zustimmung:',
        youtubeDescription: 'Um an dieser Stelle eines unserer Youtube-Videos mit spannenden Infos und Trainingstipps anzuzeigen, benötigen wir Deine Zustimmung:',
        osmDescription: 'Um an dieser Stelle eine OpenStreetMap-Karte mit unserem Standort anzuzeigen, benötigen wir Deine Zustimmung:',
        acceptExternal: 'Ich bin damit einverstanden, dass mir externe Inhalte angezeigt werden. Damit können personenbezogene Daten an Drittplattformen übermittelt werden.',
        acceptOsm: 'Ich bin damit einverstanden, dass mir die OpenStreetMap-Karte angezeigt wird. Damit können personenbezogene Daten an OpenStreetMap übermittelt werden.',
    },
    company: {
        name: 'First Class Performance GmbH',
        street: 'Vahrenwalder Str. 213',
        postcode: '30165',
        city: 'Hannover',
        country: 'Deutschland',
        phone: '+49 174 24 29 078',
        mail: 'moritz@first-class-performance.com',
        supporttext: 'Bei technischen Problemen, melde dich bitte bei `support@pnn-it.de`. Danke!',
    },
    openerVideo: {
        text: 'First Class Performance GmbH',
        probetrainingButton: 'Kennenlerngespräch buchen',
        errorMessage: 'Ihr Browser unterstützt das Videoformat nicht.',
    },
    user: {
        profile: {
            headline: 'Herzlich Willkommen, ',
            editSettings: 'Daten und Einstellungen ändern',
            content: {
                headline: 'Deine aktuellen Sportpakete',
                noPackages: 'Dir stehen aktuell keine Sportpakete zur Verfügung. Füge in den Einstellungen einen Team-Code deines Vereins hinzu, um exklusive Inhalte zu Deiner Sportart zu erhalten.',
                refreshinfo: 'Wenn du Sportpakete gekauft oder abonniert hast, versuche bitte die Seite neu zu laden (F5 oder Button unten).',
                refreshbutton: 'Pakete neu laden',
                addcode: 'Neuen Team Code hinzufügen',
            },
            accountarea: {
                headline: 'Profil-Verwaltung',
                text: 'Klicke auf den untenstehenden Button, um Deine Daten zu ändern. Um noch mehr exklusive Sportinhalte sehen zu können, kannst Du dort Team- und Rabattcodes zu deinem Account hinzuzufügen.',
            },
        },
        name: 'Name',
        firstname: 'Vorname',
        lastname: 'Nachname',
        password: 'Passwort',
        confirmPassword: 'Passwort bestätigen',
        createdOn: 'Erstellt am',
        email: 'E-Mail',
        username: 'Benutzername',
        id: 'Benutzer ID',
        locale: 'Sprache',
        settings: {
            link: 'Stammdaten/Profil bearbeiten',
            back: 'Zurück zum Profil',
            settings: 'Daten und Einstellungen verwalten',
            buys: 'Käufe',
            contact: 'Kontakt & E-Mail',
            security: 'Passwort & Sicherheit',
            teams: 'Gruppen, Mannschaften und Vereine',
            contactLink: 'Hier findest Du das Kontaktformular',
            deactivate: {
                headline: 'Account deaktivieren/löschen',
                message: 'Um deinen Account zu deaktivieren oder zu löschen, wende dich bitte über das Kontaktformular an uns.',
            },
            dsgvo: {
                headline: 'Datenschutz-Grundverordnung (DSGVO)',
                message: 'Gerne informieren wir dich über die uns bekannten Daten in Bezug auf deinen Account / deine Person. Auf Wunsch können wir diese auch löschen. Kontaktiere uns dazu bitte über das Kontaktformular.',
            },
        },
        editProfile: {
            firstname: 'Vorname',
            lastname: 'Nachname',
            save: 'Speichern',
            otherError: 'Es ist ein Fehler aufgetreten.',
            saveSuccess: 'Daten wurden erfolgreich gespeichert.',
            newsletterHeadline: 'Newsletter-Einstellung: ',
        },
        editEmail: {
            email: 'E-Mail',
            save: 'Mailadresse speichern',
            otherError: 'Es ist ein Fehler aufgetreten.',
            saveSuccess: 'Deine E-Mail wurde geändert und wir haben Dir eine E-Mail gesendet. Du wirst nun ausgeloggt. Bitte verifiziere deine E-Mail und logge Dich neu ein.',
            emailUnchanged: 'E-Mail gespeichert.',
            description: 'Hier kannst Du deine E-Mail-Adresse ändern. Wenn Du eine neue E-Mail speicherst, wirst Du ausgeloggt und musst die neue E-Mail verifizieren, um dich erneut einloggen zu können.',
            headline: 'E-Mail-Adresse ändern',
            button: 'Speichern',
            invalidEmail: 'Ungültige E-Mail-Adresse',
            emailExists: 'Diese E-Mail-Adresse wird bereits verwendet',
        },
        editPassword: {
            button: 'Passwort ändern',
            noUserError: 'Userdaten konnten nicht geladen werden.',
            success: 'Wir haben dir eine E-Mail gesendet. Bitte klicke auf den Link in der E-Mail, um dein Passwort zu ändern..',
            description: 'Hier kannst Du dein Passwort ändern. Wenn Du auf den Button klickst, senden wir die eine E-Mail mit Link, über welchen Du dein Passwort ändern kannst.',
        },
        editContactInformation: {
            saveSuccess: 'Kontaktinformationen wurden erfolgreich gespeichert.',
            enterPassword: 'Um Ihre Email Adresse zu ändern geben Sie bitte unten ihr Passwort zur Bestätigung ein.',
        },
        addTeamCode: {
            description: 'Hast Du von deinem Verein/Mannschaft einen Code erhalten, um deine sportspezifischen Inhalte zu sehen? Füge diesen Code hier deinem Account hinzzu: ',
            code: 'Team-Code',
            save: 'Team hinzufügen',
            success: 'Du bist erfolgreich dem Team beigetreten und kannst nun die Inhalte sehen',
            otherError: 'Es ist ein Fehler aufgetreten',
            codeAlready: 'Du hast diesen Code bereits deinem Account hinzugefügt',
            userLimitReached: 'Für diesen Code wurde das User-Limit erreicht. Bitte wende dich an deinen Verein oder Mannschaft.',
            notValidYet: 'Dieser Code ist noch nicht gültig',
            notValidAnymore: 'Dieser Code ist nicht mehr gültig',
            codeNotFound: 'Dieser Code wurde nicht gefunden. Bitte überprüfe deine Eingabe',
            codeRequired: 'Kein Code eingegeben',
        },
        displayTeamCodes: {
            headline: 'Meine Teams',
            text: 'Du bist Mitglied von folgenden Teams und kannst die entsprechenden Inhalte des Teams sehen:',
            delete: 'Löschen',
            deleted: 'Deine Teammitgliedschaft wurde erfolgreich gelöscht.',
            noTeams: 'Du bist noch keinen Teams beigetreten. Spreche mit deinem Verein oder Mannschaft, damit ihr ein gemeinsames Kontigent an Kurszugängen erhalten könnt. Auf diese Weise könnt ihr euch alle zusammen auf die nächste Saison vorbereiten oder das Maximum aus der Laufenden herausholen.',
            contactLink: 'Klicke hier um uns zu Vereins-, Mannschafts- und Gruppenrabatte zu kontaktieren.',
            confirmTitle: 'Teammitgliedschaft löschen',
            confirmText: 'Willst Du die Teammitgliedschaft wirklich beenden? Du kannst dann nicht mehr auf die Inhalte des Teams zugreifen. Ein Beitreten zu dem Team ist anschließend nur wieder mit einem entsprechenden Code möglich.',
            validUntil: 'Gültig bis: ',
            availablePackages: 'Als Mitglied kannst Du folgende Pakete nutzen:',
            idNotFound: 'Es ist ein Fehler beim Löschen aufgetreten',
            idRequired: 'Es ist ein Fehler beim Löschen aufgetreten.',
        },
        sendVerificationMail: {
            headline: 'Verifizierungsmail versenden',
            button: 'Verifizierungsmail versenden',
            success: 'Wir haben dir eine E-Mail mit einem Verifizierungslink gesendet. Bitte prüfe dein Postfach.',
            accountAlready: 'Zurück zum Login',
            loggedIn: 'Du bist bereits eingeloggt.',
        },
        forgotPassword: {
            headline: 'Passwort zurücksetzen ',
            text: 'Passwort vergessen? - Gib hier Deine E-Mail-Adresse ein und setze Dein Passwort zurück: ',
            success: 'Wenn ein Account zu der angegebenen Email-Adresse existiert, haben wir eine Email mit einem Link zur Zurücksetzung des Passworts gesendet.',
            submit: 'Sende Passwort-Rücksetzungs E-Mail',
            email: 'E-Mail',
            home: 'Home',
            register: 'Neues Konto erstellen',
            missingEmail: 'Bitte eine E-Mail Adresse eingeben',
            otherError: 'Es ist ein Fehler aufgetreten.',
        },
        resetPassword: {
            headline: 'Setze Dein Passwort neu',
            submit: 'Passwort ändern',
            success: 'Dein Passwort wurde erfolgreich zurückgesetzt. Bitte melde Dich an.',
            error: 'Es ist ein Fehler aufgetreten. Bitte lasse dir eine neue E-Mail zusenden, um dein Passwort zurückzusetzen.',
            problem: 'Es ist kein valider Code gesetzt.',
            forgotPassword: 'Passwort vergessen? Klicke hier um deine E-Mail anzugeben und eine Mail zum Zurücksetzen zu erhalten.',
            password: 'Passwort',
            confirmPassword: 'Passwort bestätigen',
            passwordMismatch: 'Die Passwörter müssen übereinstimmen',
            passwordMissing: 'Bitte Passwort und Passwortbestätigung ausfüllen',
            login: 'Passwort erfolgreich zurückgesetzt. Jetzt hier einloggen.',
            text: 'Bitte gib dein neues Passwort ein:',
        },
        login: {
            headline: 'Zur Member-Area anmelden',
            email: 'E-Mail',
            password: 'Passwort',
            missingData: 'Usernamen/E-Mail und Passwort eingeben.',
            errorOther: 'Es ist ein Fehler aufgetreten',
            errorWrongCredentials: 'Falsche Login-Daten.',
            errorNoValidation: 'Wir haben dir eine E-Mail geschickt. Bitte verifiziere zuerst Deine E-Mail, bevor Du Dich einloggen kannst.',
            blocked: 'Account blockiert',
            passwordformat: 'Dein Passwort darf nicht mehr als dreimal das Symbol `$` enthalten.',
            ratelimit: 'Zu viele Versuche, bitte versuche es in einer Minute erneut.',
            connrefused: 'Serververbindung fehlgeschlagen.',
            registered: 'Du hast dich erfolgreich registriert. Validiere deine E-Mail-Adresse und du kannst Dich nun einloggen.',
            validated: 'Du hast erfolgreich deine E-Mail-Adresse bestätigt und kannst Dich nun einloggen.',
            headlineText: 'Melde Dich mit Deiner E-Mail-Adresse und Passwort an.',
            signIn: 'Anmelden',
            forgotPassword: 'Passwort vergessen',
            noAccount: 'Neues Konto erstellen',
            socialHeader: 'Oder mit einem Klick anmelden',
            googleLogin: 'mit Google einloggen',
            sendVerificationMail: 'Keine Mail zur Verifizierung erhalten? Lasse dir hier eine Neue senden.',
            unconfirmedEmail: 'Bitte bestätige zuerst deine E-Mail-Adresse.',
            loginTitle: 'Anmelden',
            errorMail: 'Diese E-Mail-Adresse ist uns nicht bekannt.',
            errorPassword: 'Dein Passwort ist falsch.',
        },
        register: {
            headline: 'Registrieren',
            button: 'Registrieren',
            marketingOpt: 'Ich möchte Updates und Marketing-E-Mails erhalten',
            accountAlready: 'Du hast bereits ein Konto? Anmelden',
            alreadyRegistered: 'Du bist bereits registriert',
            missingFirstname: 'Bitte Vornamen angeben.',
            missingLastname: 'Bitte Nachnamen angeben.',
            missingEmail: 'Bitte E-Mail-Adresse angeben.',
            missingPassword: 'Bitte Passwort angeben.',
            missingPassword2: 'Bitte Passwort bestätigen.',
            passwordMissmatch: 'Die Passwörter stimmen nicht überein.',
            passwordTooShort: 'Das Passwort muss mindestens 8 Zeichen enthalten.',
            passwordCharacters: 'Das Passwort muss mindestens einen Buchstaben und eine Zahl enthalten',
            invalidEmail: 'Ungültige E-Mail-Adresse.',
            accountExists: 'Zu dieser E-Mail-Adresse existiert bereits ein Account.',
            otherError: 'Es ist ein Fehler aufgetreten',
        },
        emailVerification: {
            headline: 'E-Mail Verifizierung',
            error: 'Es ist ein Fehler aufgetreten oder Deine E-Mail ist bereits verifiziert. Bitte versuchen Sie es später erneut.',
            loading: 'Wir verifizieren Deine E-Mail. Habe bitte einen kurzen Augenblick Geduld.',
            verification: 'Verifizierung',
            button: 'Email verifizieren',
            success: 'Deine E-Mail wurde erfolgreich verifiziert. Du wirst automatisch zum Login weitergeleitet.',
            invalidToken: 'Ungültiger Token.',
            alreadyVerified: 'Deine E-Mail wurde bereits verifiziert. Du wirst automatisch zum Login weitergeleitet.',
        },
    },
    error: {
        title: 'Etwas ist schief gelaufen',
        message: 'Es tut uns leid, aber es ist ein unerwarteter Fehler aufgetreten.',
        tryAgain: 'Erneut versuchen',
        backToHome: 'Zurück zur Startseite',
    },
    notFound: {
        title: '404 - Seite nicht gefunden',
        message: 'Die angeforderte Seite konnte nicht gefunden werden.',
        backToHome: 'Zurück zur Startseite',
        contactUs: 'Kontaktieren Sie uns',
        recommendedTitle: 'Empfohlene Seiten',
        recommendedLinks: {
            home: 'Startseite',
            courses: 'Kurse',
            fitness: 'Fitness',
            trial: 'Probetraining',
        },
    },
    cookies: {
        settings: 'Cookie-Einstellungen',
    },
}

export default de
